/**
 * Reusable pagination control matching the backend response shape:
 *   pagination: { total, page, pages, limit }
 *
 * Renders nothing when there is one page or less.
 *
 * @example
 *   <Pagination page={page} pages={pagination.pages} onChange={setPage} />
 */
const Pagination = ({ page, pages, onChange, className = '', disabled = false }) => {
  if (!pages || pages <= 1) return null;

  const handlePrev = () => !disabled && page > 1 && onChange(page - 1);
  const handleNext = () => !disabled && page < pages && onChange(page + 1);

  return (
    <nav
      aria-label="Pagination"
      className={`flex items-center justify-center gap-2 ${className}`}
    >
      <button
        type="button"
        disabled={disabled || page <= 1}
        onClick={handlePrev}
        className="px-3 py-1.5 text-sm border rounded-lg disabled:opacity-50 hover:bg-gray-50"
      >
        Previous
      </button>
      <span className="text-sm text-black" aria-live="polite">
        Page {page} of {pages}
      </span>
      <button
        type="button"
        disabled={disabled || page >= pages}
        onClick={handleNext}
        className="px-3 py-1.5 text-sm border rounded-lg disabled:opacity-50 hover:bg-gray-50"
      >
        Next
      </button>
    </nav>
  );
};

export default Pagination;
